var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8414 0.904053L12.3824 6.32792L17.8414 11.7518C17.9401 11.5455 18 11.3175 18 11.074V1.58183C18 1.3383 17.9401 1.11031 17.8414 0.904053Z",
    fill: "#AABFD7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4179 0H1.582C1.33847 0 1.11048 0.0598712 0.904221 0.158555L7.88143 7.10061C8.49836 7.71754 9.50157 7.71754 10.1185 7.10061L17.0957 0.158555C16.8894 0.0598712 16.6615 0 16.4179 0Z",
    fill: "#AABFD7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.158555 0.904053C0.0598711 1.11031 0 1.3383 0 1.58183V11.074C0 11.3175 0.0598711 11.5456 0.158555 11.7518L5.61758 6.32792L0.158555 0.904053Z",
    fill: "#AABFD7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6367 7.07373L10.8642 7.84622C9.83626 8.87415 8.16363 8.87415 7.1357 7.84622L6.36325 7.07373L0.904221 12.4976C1.11048 12.5963 1.33847 12.6562 1.582 12.6562H16.4179C16.6615 12.6562 16.8894 12.5963 17.0957 12.4976L11.6367 7.07373Z",
    fill: "#AABFD7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.492637a43eb9fd0bbd6188397cf838f3.svg";
export { ForwardRef as ReactComponent };